export const routesWithPrefix = (
    prefix,
    name = null,
    middleware = [],
    routes
) => {
    return routes.map((route) => {
        if (prefix && prefix !== '') {
            route.path = `${prefix}${route.path}`;
        }
        if (name && name !== '') {
            route.name = name + '.' + route.name;
        }
        if (typeof middleware === 'object') {
            let routerMiddleware = route.meta?.middleware || [];
            route.meta = {
                ...route.meta,
                middleware: [...middleware, ...routerMiddleware],
            };
        }
        return route;
    });
};
